exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".todo-item[data-v-54ab45aa] {\n  display: flex;\n  align-items: center;\n}\n.todo-item-label[data-v-54ab45aa] {\n  display: flex;\n  cursor: pointer;\n}\n.todo-item-checkbox[data-v-54ab45aa] {\n  opacity: 0;\n  left: -999rem;\n  position: absolute;\n}\n.todo-item-name[data-v-54ab45aa] {\n  flex-grow: 1;\n}\n.todo-item.completed .todo-item-name[data-v-54ab45aa] {\n  text-decoration: line-through;\n}", ""]);

// exports
